export default __webpack_public_path__ + "static/media/000_intro_part2.2921b5dd.mp4";